module.exports = __webpack_public_path__ + "static/media/ic-create.2093c38f.svg";